app.component("referralTypesSelector", {
	templateUrl: "app/src/js/components/userDetails/referralTypesSelector.component.html",
	controller: "referralTypesSelectorController",
});

app.controller("referralTypesSelectorController", [
	"$scope",
	"Session",
    "UserService",
    "REFERRAL_REASON_OPHTHALMOLOGIST",
    "REFERRAL_REASON_OPTOMETRIST",
    "REFERRAL_REASON_RESTRICTED",
	function ($scope, Session,UserService,
        REFERRAL_REASON_OPHTHALMOLOGIST, REFERRAL_REASON_OPTOMETRIST, REFERRAL_REASON_RESTRICTED) {
        $scope.US = UserService;
        $scope.displayErrorMsg = false;

        // Types the user already has listed but that aren't rendered, because their practice
        // does not have the matching feature. They stay listed - not showing a checkbox should
        // not silently un-list the user the next time they tick something else.
        let hiddenListedReferralTypes = [];
		this.$onInit = function () {
			$scope.Session = Session;
			$scope.maxNumberOfListedReferralTypes = Session.user.features.maxNumberOfListedReferralTypes;

            $scope.options = [];

            // Restricted types are only offered to practices that have the matching practice feature.
            const hasPhotobiomodulationReferralTypeFeature = Session.practice
                && Session.practice.practiceFeatures
                && Session.practice.practiceFeatures.photobiomodulationReferralTypeFeature;

            const restrictedOptions = hasPhotobiomodulationReferralTypeFeature
                ? angular.copy(REFERRAL_REASON_RESTRICTED)
                : [];

			if (["OPTOMETRIST"].some((t) => Session.user.roles.includes(t))) {
                $scope.options = [
                    ...angular.copy(REFERRAL_REASON_OPTOMETRIST),
                    ...restrictedOptions
                ];
			} else if (["OPHTHALMOLOGIST"].some((t) => Session.user.roles.includes(t))) {
                $scope.options = [
                    ...angular.copy(REFERRAL_REASON_OPHTHALMOLOGIST),
                    ...restrictedOptions
                ];
			}

            fetchReferalTypes();
		};

        function fn () {
            const data = [
                ...$scope.options.filter(t=>t.selected).map(t=>t.value),
                ...hiddenListedReferralTypes
            ];
            if(data.length >= $scope.maxNumberOfListedReferralTypes){
                $scope.displayErrorMsg = true;
            }else{
                $scope.displayErrorMsg = false;
            }
            return data;
        }

        function fetchReferalTypes() {
			$scope.US.getUser().then(
				function (resp) {
                    const listedReferralTypes = resp.data.features.listedReferralTypes || [];
                    $scope.options.forEach((t) => {
                        if (listedReferralTypes.some((m) => m === t.value)) {
                            t.selected = true;
                        }
                    });
                    hiddenListedReferralTypes = listedReferralTypes.filter(
                        (m) => !$scope.options.some((t) => t.value === m)
                    );
                    fn();
                },
				function (error) {
                    console.error("Failed to load referral types", error && error.status);
                }
			);
		}

        $scope.onOptionChange = function() {
            $scope.US.updateReferralTypes(fn()).then(
                function () {},
                function (error) {
                    console.error("Failed to save referral types", error && error.status);
                }
            );
        }
	},
]);
